import React from "react";
import PolicyLayout from "@/components/PolicyLayout";

export default function Privacy() {
  return (
    <PolicyLayout
      title="Privacy policy"
      description="How PeptiChill collects, stores and processes your personal data under UK GDPR."
      path="/privacy"
      eyebrow="Privacy"
      lastUpdated="February 2026"
    >
      <p>
        This Privacy Policy explains how PeptiChill (&ldquo;we&rdquo;, &ldquo;us&rdquo;)
        collects, uses and protects information you provide when using our website,
        peptidecooler.co.uk, in accordance with the <strong>UK General Data Protection
        Regulation (UK GDPR)</strong> and the <strong>Data Protection Act 2018</strong>.
      </p>

      <h2>Data we collect</h2>
      <ul>
        <li>
          <strong>Order data:</strong> name, billing &amp; delivery address, email, phone
          number, and order details.
        </li>
        <li>
          <strong>Payment data:</strong> processed directly by our payment provider (Stripe).
          We do <em>not</em> store full card details on our servers.
        </li>
        <li>
          <strong>Contact form data:</strong> name, email, and the contents of your message.
        </li>
        <li>
          <strong>Technical data:</strong> IP address, browser type, device type and pages
          viewed via cookies and analytics tools (only with your consent).
        </li>
      </ul>

      <h2>Why we use it &amp; lawful basis</h2>
      <ul>
        <li>
          <strong>To fulfil orders</strong> — lawful basis: performance of a contract.
        </li>
        <li>
          <strong>To respond to enquiries</strong> — lawful basis: legitimate interests.
        </li>
        <li>
          <strong>To send marketing emails</strong> — lawful basis: consent (you may
          withdraw at any time via the unsubscribe link).
        </li>
        <li>
          <strong>To comply with legal obligations</strong> — e.g. retaining invoices for
          HMRC.
        </li>
      </ul>

      <h2>Cookies</h2>
      <p>
        We use a small number of essential cookies that are required for the site to
        function (e.g. cart, session). With your consent we also use optional analytics
        cookies (e.g. PostHog) to understand how the site is used. You can change your
        choice any time by clearing your browser&rsquo;s site data and revisiting the
        cookie banner.
      </p>

      <h2>Third parties we share data with</h2>
      <ul>
        <li><strong>Stripe</strong> — payment processing</li>
        <li><strong>Email service provider</strong> — order &amp; transactional emails {/* [REVIEW] confirm provider once selected */}</li>
        <li><strong>Shipping carriers</strong> — to deliver your order</li>
        <li><strong>Analytics</strong> — anonymised usage data, only if you consent</li>
      </ul>
      <p>
        We do not sell your data, ever. We only share what&rsquo;s strictly needed for the
        service you&rsquo;ve asked for.
      </p>

      <h2>How long we keep data</h2>
      <p>
        Order records are retained for <strong>6 years</strong> to comply with UK tax law.
        Contact form messages are retained for up to 24 months unless legally required to
        be kept longer.
      </p>

      <h2>Your rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Request a copy of the personal data we hold about you (subject access request)</li>
        <li>Have inaccurate data corrected</li>
        <li>Request erasure of your data where there is no overriding lawful basis to keep it</li>
        <li>Restrict or object to processing</li>
        <li>Withdraw consent for marketing at any time</li>
        <li>Lodge a complaint with the Information Commissioner&rsquo;s Office (ICO)</li>
      </ul>

      <h2>How to contact us</h2>
      <p>
        Email <a href="mailto:hello@peptidecooler.co.uk">hello@peptidecooler.co.uk</a>{" "}
        with any privacy queries or data requests. We&rsquo;ll respond within 30 days.
      </p>
    </PolicyLayout>
  );
}
